// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1PC1L","dragIcon":"Choice_dragIcon__3EeTj","left":"Choice_left__w7jnL","input":"Choice_input__3qWIg"};